import { render, staticRenderFns } from "./card4.vue?vue&type=template&id=efc24c1c&"
import script from "./card4.vue?vue&type=script&lang=js&"
export * from "./card4.vue?vue&type=script&lang=js&"
import style0 from "./card4.vue?vue&type=style&index=0&id=efc24c1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports